<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <!-- TODO INDY-3739 Allow overwriting labels -->
    <iso-date-input
      v-model="conditional.conditionsRequirements[dateRangeStartField]"
      emit-string="nullify-blank"
      class="col-4"
      :label="$_.startCase(dateRangeStartField)"
      clearable
      :rules="[
        val => val !== null || 'Field is required',
        () => !conditional.conditionsRequirements[dateRangeEndField] || conditional.conditionsRequirements[dateRangeStartField] <= conditional.conditionsRequirements[dateRangeEndField] || 'Date cannot postdate end date',
      ]"
    />
    <iso-date-input
      v-model="conditional.conditionsRequirements[dateRangeEndField]"
      emit-string="nullify-blank"
      class="col-4"
      :label="$_.startCase(dateRangeEndField)"
      clearable
      :rules="[
        val => val !== null || 'Field is required',
        () => !conditional.conditionsRequirements[dateRangeStartField] || conditional.conditionsRequirements[dateRangeEndField] >= conditional.conditionsRequirements[dateRangeStartField] || 'Date cannot predate start date',
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDateRangeField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'

export default {
  name: 'DateRangeConditionForm',
  components: {
    IsoDateInput
  },
  props: {
    conditional: {
      type: Object,
      required: true
    },
    dateRangeStartField: {
      type: String,
      default: CONDITION_REQUIREMENTS.DATE_RANGE_START
    },
    dateRangeEndField: {
      type: String,
      default: CONDITION_REQUIREMENTS.DATE_RANGE_END
    },
    excludeDateRangeField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_DATE_RANGE
    }
  }
}

</script>
